import { useParams } from 'react-router-dom';

import type { PharmacistsControlDetailPathParams } from '@/router/paths/dorim-promo.path';

export const usePharmacistIdFromPathParams = () => {
  const routerParams = useParams<PharmacistsControlDetailPathParams>();
  return Number(routerParams.pharmacistId);
};
